import * as React from "react";

import { INavigationState } from "VersionControl/Scripts/Actions/PullRequestReview/ActionsHub";
import { getHistoryService } from "VSS/Navigation/Services";

export interface FileLinkProps {
    id?: string;
    itemPath: string;
    discussionId?: number;
    iteration?: number;
    base?: number;
    text?: string;
    cssClass?: string;
    isPreview?: boolean;
}

export class FileLink extends React.Component<FileLinkProps, {}> {
    public render(): JSX.Element {
        const state: INavigationState = {
            path: this.props.itemPath,
            discussionId: this.props.discussionId || null,
            iteration: this.props.iteration || null,
            base: this.props.base || null,
            isPreview: this.props.isPreview || null,
        };
        const text = this.props.text || this.props.itemPath;
        return (
            <a id={this.props.id} className={this.props.cssClass} href={getHistoryService().getFragmentActionLink("files", state)}>
                {this.props.text ? this.props.text : this.props.children}
            </a>
        );
    }
}
